/* eslint-disable prettier/prettier */
import { ContactsOutlined } from "@material-ui/icons";
import React, { Component } from "react";
import styled from "styled-components";
import { Help, ExitGameSymbol, TargetIcon } from "../../Constants/assets";

// Stylings
// small pop up styling
const InnerContainer = styled.div`
  position: absolute;
  top: 18%;
  left: 2%;
  z-index: 24;
  height: 200px;
  display: grid;
`;

const ColumnContainer = styled.div`
  display: grid;
`;
const IconContainer = styled.div`
  width: 56px;
  height: 56px;
  opacity: 0.9;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  background: ${(props) => props.theme.colors.white};

  :hover {
    cursor: pointer;
  }
`;
const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
`;
// TODO: Fix this, this is temporary fix
const LeftSideIcons = ({ handleRestartMap, toggleInfo, quitGameModal }) => {
  // TODO: Fix this, this is temporary fix
  return (
    <InnerContainer>
      {/* <TimerContainer>{this.state.seconds}</TimerContainer> */}
      {/* <Timer /> */}
      <ColumnContainer>
        <IconContainer>
          <HelpContainer onClick={() => toggleInfo(true)}>
            <Help />
          </HelpContainer>
        </IconContainer>
        <IconContainer>
          <HelpContainer onClick={() => handleRestartMap()}>
            <TargetIcon />
          </HelpContainer>
        </IconContainer>
        <IconContainer>
          <HelpContainer id="quit-game" onClick={() => quitGameModal()}>
            <ExitGameSymbol />
          </HelpContainer>
        </IconContainer>
      </ColumnContainer>
    </InnerContainer>
  );
};
export default React.memo(LeftSideIcons);
